import pdfMake, { userMark, setMyConfig, makeTableContent } from "@/utils/pdf";

function pdfReporteGuias(payload) {
  const columns = [
    {
      key: "codigo",
      label: "Cód.",
      width: "auto",
    },
    {
      key: "tabla",
      label: "Tabla",
      width: "auto",
    },
    {
      key: "fecha",
      label: "Fecha",
      width: "auto",
    },
    {
      key: "pasajero",
      label: "Pasajero",
      width: "*",
    },
    {
      key: "agencia",
      label: "Agencia",
      width: "*",
    },
    {
      key: "servicio",
      label: "Servicio",
      width: "*",
    },
    {
      key: "tipoServicio",
      label: "Tipo",
      width: 30,
    },
    {
      key: "pax",
      label: "PAX",
      width: 30,
    },
    {
      key: "chd",
      label: "CHD",
      width: 30,
    },
    {
      key: "idioma",
      label: "Idioma",
      width: 30,
    },
    {
      key: "usuarioCreador",
      label: "U. Creador",
      width: 100,
    },
  ];

  const table = makeTableContent([...payload.registros], columns);

  pdfMake
    .createPdf({
      info: {
        title: `Reporte de actividad de guías por fecha`,
      },
      content: [
        {
          text: "Reporte de actividad de guías por fecha",
          style: "h1",
        },
        {
          columns: [
            {
              text: `Guía: ${payload.header.guia}`,
              width: "auto",
            },
            {
              text: `Fecha Inicio: ${payload.header.fecha_inicio}`,
              width: "auto",
            },
            {
              text: `Fecha Fin: ${payload.header.fecha_fin}`,
              width: "auto",
            },
            {
              text: `Usuario: ${payload.header.usuario}`,
              width: "auto",
            },
          ],
          margin: [0, 0, 0, 5],
        },
        table,
        ...userMark(payload.userMark, payload.dateMark),
      ],
      ...setMyConfig(),
    })
    .print();
}

export default pdfReporteGuias;
